import { render } from "./spinner.vue?vue&type=template&id=c643fade&scoped=true"
const script = {}

import "./spinner.vue?vue&type=style&index=0&id=c643fade&lang=scss&scoped=true"

import exportComponent from "F:\\200 Desarrollos\\SIE\\SIE-Publico\\SIE.Frontend\\WEB.Home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c643fade"]])

export default __exports__